import { Component, ReactNode } from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
  errorInfo: string | null;
}

export class NginxErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: { componentStack?: string | null }) {
    this.setState({ errorInfo: errorInfo.componentStack || null });
    console.error('NginxAnalytics Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6">
          <Card className="border-destructive">
            <CardContent className="pt-6">
              <div className="space-y-4">
                <p className="text-destructive font-medium">Erro no Dashboard VPS</p>
                <pre className="text-xs bg-muted p-4 rounded-lg overflow-auto max-h-48 whitespace-pre-wrap">
                  {this.state.error?.message}
                  {'\n\n'}
                  {this.state.error?.stack}
                </pre>
                {this.state.errorInfo && (
                  <pre className="text-xs bg-muted p-4 rounded-lg overflow-auto max-h-48 whitespace-pre-wrap">
                    Component Stack:{this.state.errorInfo}
                  </pre>
                )}
                <Button onClick={() => this.setState({ hasError: false, error: null, errorInfo: null })}>
                  Tentar Novamente
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      );
    }

    return this.props.children;
  }
}
